import { objectSpread2 as _objectSpread2 } from "../_virtual/_rollupPluginBabelHelpers.js";
function getConfig(cfg) {
  var media = (cfg === null || cfg === void 0 ? void 0 : cfg.media) || document.createElement("video");
  return _objectSpread2(_objectSpread2({
    maxPlaylistSize: 50,
    retryCount: 3,
    retryDelay: 1e3,
    pollRetryCount: 2,
    loadTimeout: 1e4,
    manifestLoadTimeout: 1e4,
    preloadTime: 30,
    softDecode: false,
    bufferBehind: 10,
    maxJumpDistance: 3,
    startTime: 0,
    useLowLatency: true,
    targetLatency: 10,
    maxLatency: 20,
    allowedStreamTrackChange: true,
    seiInTime: false,
    manifestList: [],
    minSegmentsStartPlay: 3,
    preferMMS: false,
    preferMMSStreaming: false,
    mseLowLatency: true
  }, cfg), {}, {
    media
  });
}
export { getConfig };
